<template>
  <div>
    <div style="font-size:11px;">簡易プレビュー</div>
    <div
      data-v-f3f3eg9
      id="preview"
      v-html="add_html+evaluation"
      style="border: 1px solid rgb(170, 170, 170);padding: 0 10px;overflow: scroll;"
    ></div>
  </div>
</template>

<script>
// import { insertHtmlTag } from "../constants/constants.js";

export default {
  // item配列受け取り
  props: {
    evaluation: String,
    add_html: String
  },

  methods: {
    // // リミットに応じてカードの背景色変更
    // getBackgroundColor(limit, type) {
    //   var color = "";
    //   if (type == "deck") {
    //     return "white";
    //   }
    //   if (limit == "") {
    //     color = "white";
    //   } else if (limit == "準制限") {
    //     color = "rgb(143 212 255)";
    //   } else if (limit == "制限") {
    //     color = "rgb(255 190 141)";
    //   } else if (limit == "禁止") {
    //     color = "#ff9c9c";
    //   }
    //   return color;
    // },
    // // リミットに応じてカード名文字色変更
    // getTextColor(limit, type) {
    //   var color = "";
    //   if (type == "deck") {
    //     return "#212121";
    //   }
    //   if (limit == "") {
    //     color = "#212121";
    //   } else if (limit == "準制限") {
    //     color = "rgb(0 97 157)";
    //   } else if (limit == "制限") {
    //     color = "rgb(157 78 2)";
    //   } else if (limit == "禁止") {
    //     color = "#bd0000";
    //   }
    //   return color;
    // },
    // // カード選択時
    // // 呼び出し元に投げる
    // itemClick(item) {
    //   if (this.$listeners["editItem"]) {
    //     this.$emit("editItem", item);
    //   }
    // },
    // // クリップボードにコピー
    // // 呼び出し元に投げる
    // itemCopy(item, img) {
    //   if (this.$listeners["editItem"]) {
    //     this.$emit("copyToClipboard", item, img);
    //   }
    // },
    // // クリップボードにコピー2
    // // 呼び出し元に投げる(デッキのショートコード)
    // itemCopy2(item, img) {
    //   if (this.$listeners["editItem"]) {
    //     this.$emit("copyToClipboard2", item, img);
    //   }
    // }
  }
};
</script>
<style>
#preview h3 {
  margin: 10px 0px 15px 0px;
  color: #38434b;
  padding: 5px 0 5px 10px;
  border-left: 6px solid #38434b;
  border-bottom: 1px solid #d4d4d4;
  font-size: 14px;
}
#preview h4 {
  color: #444;
  border-left: 4px solid #e0e0e0;
  margin-top: 10px;
  padding: 0 0 0 7px;
  margin-bottom: 10px;
  font-size: 13px;
  line-height: 24px;
  text-indent: 3px;
}
#preview p {
  font-size: 13px;
  line-height: 1.6em;
  color: #222;
}

#preview .checklists {
  background-color: #fff;
  border: 1px solid #dbe4ea;
  border-radius: 2px;
  margin-bottom: 14px;
  padding: 6px 10px;
  margin-top: 14px;
}
#preview .checklists strong {
  padding: 0px 0px 5px 0px;
  display: block;
  text-align: left;
  margin: 0 auto;
  font-size: 13px;
  color: #555;
  background-color: transparent;
  background-image: none;
  text-shadow: none;
  box-shadow: none;
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 2px solid #38434b;
}
#preview .checklists ul {
  margin: 0;
  padding: 0;
  list-style: none !important;
}
#preview .checklists ul li {
  text-align: left;
  font-size: 12px;
  line-height: 1em;
  padding: 3px 10px 0px 33px;
  border-bottom: 2px dotted #ccd9e2;
  font-weight: bold;
  margin: 0;
  text-indent: -30px;
}
#preview.checklists ul li:first-child {
  padding: 0 10px 0 33px;
}
#preview .checklists ul li:before {
  content: "";
  display: inline-block;
  position: relative;
  top: -2px;
  background: url(https://admin.appmedia.jp/wp-content/themes/appmedia/images/common/img/icon_sprite.png)
    no-repeat -1px -181px;
  background-size: 512px 512px;
  width: 27px;
  height: 25px;
  background-repeat: no-repeat;
  vertical-align: middle;
  transform: scale(0.7);
  left: -3px;
}
</style>